<template>
    <div class="content">
        <container v-if="!loaded">
            <loading />
        </container>

        <div class="md-layout" v-if="loaded">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
                style="margin-bottom:15px">
                <h4 class="application-title" style="font-weight: bold;">{{application.service_name}}</h4>
            </div>
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50"
                style="display: flex;">
                <container>
                    <h4 class="application-title" style="font-weight: bold;">{{translate(locale.reviewing_comment)}}
                    </h4>
                    <div class="container">
                        <div class="timeline">
                            <div class="timeline-container" v-for="(timeline, index) in timeline_list">
                                <div class="timeline-icon"></div>
                                <div class="timeline-body">
                                    <h4 class="timeline-title">
                                        <template v-if="timeline.status == 'REVIEWING'">
                                            <span class="badge"> {{timeline.user_name}} ({{timeline.unit_name}})</span>
                                        </template>
                                        <template v-else>
                                            <span class="badge">{{translate(config.getStatus(timeline.status))}}</span>
                                        </template>

                                        <template v-if="timeline.status == 'APPROVED' || timeline.status == 'STAMPED' || timeline.status == 'STAMPED' || timeline.status == 'COMPLETED' || timeline.status == 'RETURNED' ||  timeline.status == 'REJECTED'">
                                            <span class="badge"> {{translate(locale.by)}} {{timeline.user_name}} ({{timeline.unit_name}})</span>
                                        </template>

                                        <span class="timeline-date"> •
                                            {{translate(config.datelify(timeline.created_date))}}</span>
                                    </h4>
                                    <p class="timeline-comment" v-if="timeline.comment">{{timeline.comment}}</p>
                                    <p class="timeline-comment" v-if="timeline.comment_to_user != ''">{{translate(locale.comment_to_applicant)}}: <br>{{timeline.comment_to_user}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </container>
            </div>

            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="display: flex;">
                <container>
                    <h4 class="application-title" style="font-weight: bold;">{{translate(locale.workspace)}}</h4>
                    <div class="md-layout">
                        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                            <form-textarea v-model="workspace.note" :label="locale.internal_note" type="text" :required="false" :height="100" />
                        </div>
                        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                            <md-button class="md-raised md-primary" @click="save_workspace()"><i class="material-icons button-icon">save</i> {{translate(locale.save)}}</md-button>
                        </div>
                    </div>
                    <template v-if="application.certificate != null">
                        <h4 class="application-title" style="font-weight: bold;">{{translate(locale.certificate_setting)}}</h4>
                        <div class="md-layout">
                            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                                <iframe :src="config.verify_base_url + application.certificate" style="width: 100%; height: 500px; border: 0; border-radius: 6px;"></iframe>
                                <md-button class="md-raised md-primary action-button" @click="certificate_preview = true"><i class="material-icons button-icon">visibility</i> {{translate(locale.preview)}}</md-button>
                            </div>
                        </div>
                    </template>
                </container>
            </div>

            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                <container>
                    <h4 class="text-primary text-center"><b>{{translate(locale.application_form)}}</b></h4>
                    <HPC_FORM :data="application" v-if="service_form_hash == 'HPC_FORM'" />
                </container>
            </div>
        </div>

        <Preview v-if="certificate_preview" :data="{name: translate(locale.certificate_setting), url: config.verify_base_url + application.certificate}" @close="certificate_preview = false" />
    </div>
</template>

<script>
    import HPC_FORM from "../../forms/HPC_FORM.vue";
    import Preview from "../../components/Preview.vue";

    export default {
        components: {
            HPC_FORM, Preview
        },
        created() {
            this.getApplication();
        },
        data() {
            return {
                loaded: false,
                form_list: ["HPC_FORM"],
                service_form_hash: "",
                application: null,
                timeline_list: [],
                workspace: {
                    note: ""
                },
                certificate_preview: false,

            }
        },
        methods: {
            getApplication() {
                this.$http.get(this.config.api + "/user/application/get/" + this.$route.params.hash).then(data => {

                    if (data.body.status == 'success') {
                        this.loaded = true;
                        this.service_form_hash = data.body.data.application.service_form_hash;
                        this.application = data.body.data.application;
                        this.timeline_list = data.body.data.timeline_list;
                        this.workspace.note = data.body.data.application.note;
                    } else {
                        this.$router.push("/pending_applications");
                    }
                });
            },
            save_workspace() {
                this.$http.post(this.config.api + "/user/application/save", {
                    hash: this.$route.params.hash,
                    workspace: this.workspace
                }).then(res => {
                    if (res.body.status == 'success') {
                        this.$notification.notify({
                            message: "Success !||ជោគជ័យ។",
                            icon: 'check_circle',
                            type: 'success'
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .dialog-container {
        width: 90%;
        max-width: 800px !important;
        padding: 15px;
        border-radius: 6px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }

    .action-button {
        margin-left: 8px;
    }

    .timeline {

        position: relative;
        padding-left: 3rem;
        margin: 0 0 0 10px;
        color: #353690;
    }

    .timeline .timeline-container {
        position: relative;
        margin-bottom: 20px;
    }

    .timeline .timeline-container .timeline-icon {
        position: absolute;
        left: -55px;
        top: 20px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #353690;
    }

    .timeline .timeline-container .timeline-body {
        background: #F7F7F7;
        border-radius: 6px;
        padding: 5px 15px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    }

    .timeline-date {
        margin-bottom: 0;
        font-size: 13px;
    }

    .timeline .timeline-container .timeline-body:before {
        content: "";
        background: inherit;
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        top: 20px;
        left: -10px;
        transform: rotate(45deg);
        border-radius: 0 0 0 6px;
    }

    .timeline .timeline-container .timeline-body .timeline-title {
        margin-bottom: 8px;
        margin-top: 0px;
    }

    .timeline .timeline-container .timeline-body .timeline-title .badge {
        /* padding: 4px 8px; */
        border-radius: 3px;
        font-size: 15px;
        font-weight: bold;
    }

    .timeline-comment {
        white-space: pre-wrap;
    }
</style>


// WEBPACK FOOTER //
// src/pages/OngoingApplications/Detail.vue